import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Tender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            TENDER: false,
            ARCHIVE: {},
            SHOW_ARCHIVE: false,
            COMMENT: ''
        }
    }

    componentDidMount = () => {
        this.fetchSupplierArchive()
        this.fetchTenderData()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    removeProductFromArchive = async (pid) => {
        try {
            let SEND_DATA = {
                product_id: pid
            };

            let data = await Request(SEND_DATA, 'tenders/remove-from-archive');
            if (data !== false) {
                this.fetchSupplierArchive();
            }
        } catch (error) {
        }
    }

    addProductToArchive = async (pid) => {
        try {
            let SEND_DATA = {
                product_id: pid
            };

            let data = await Request(SEND_DATA, 'tenders/add-to-archive');
            if (data !== false) {
                this.fetchSupplierArchive();
            }
        } catch (error) {
        }
    }

    fetchSupplierArchive = async () => {
        try {
            let SEND_DATA = {};

            let data = await Request(SEND_DATA, 'tenders/archive');
            if (data !== false) {
                this.setState({ ARCHIVE: data });
            } else {
                this.setState({ ARCHIVE: {} });
            }
        } catch (error) {
        }
    }

    fetchTenderData = async () => {
        let id = this.props.match.params.id;

        try {
            let SEND_DATA = {};

            let data = await Request(SEND_DATA, 'tenders/' + id);
            if (data !== false) {
                this.setState({ TENDER: data, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    submitTender = async () => {
        let id = this.props.match.params.id;

        try {
            let SEND_DATA = {
                id: id,
                products: this.state.TENDER.products,
                comment: this.state.COMMENT
            };

            let data = await Request(SEND_DATA, 'tenders/submit');
            if (data !== false) {
                this.fetchTenderData()
            } else {
            }
        } catch (error) {
        }
    }

    changePrice = (price, id) => {
        let TENDER = Object.assign({}, this.state.TENDER)

        for (let i = 0; i < TENDER.products.length; i++) {
            if (TENDER.products[i].id == id) {
                TENDER.products[i].orderPrice = price
            }
        }

        this.setState({ TENDER: TENDER })
    }

    changeComment = (amount, id) => {
        let TENDER = Object.assign({}, this.state.TENDER)

        for (let i = 0; i < TENDER.products.length; i++) {
            if (TENDER.products[i].id == id) {
                TENDER.products[i].orderComment = amount
            }
        }

        this.setState({ TENDER: TENDER })
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={ SRC }
                />
            );
        }

        return false;
    }

    renderStatusBadge = (status) => {
        let title = 'Новый';
        let className = 'new';

        switch (parseInt(status)) {
            case 1:
                title = 'Активный';
                className = 'talk';
                break;
            case 2:
                title = 'Завершен';
                className = 'done';
                break;
        }

        return <span className={ 'order_status ' + className }>{ title }</span>
    }

    renderProductsRows = (locked = false) => {
        let ROWS = [];
        let rowNumb = 0
        for (let i = 0; i < this.state.TENDER.products.length; i++) {
            let PRODUCT = this.state.TENDER.products[i];
            let numb = i + 1;

            const inArchive = typeof this.state.ARCHIVE[PRODUCT.id] == "undefined" ? false : true

            if (inArchive) {
                continue
            }

            rowNumb++

            ROWS.push(
                <tr key={ i } className={ inArchive ? 'tenderArchive' : ''}>
                    <td className="cell-center">{ rowNumb }</td>
                    <td className="cell-center">
                        { this.renderImage(PRODUCT) }
                        </td>
                    <td>
                        <span className="product_title">{ PRODUCT.name }</span>
                        { PRODUCT.tenderComment && PRODUCT.tenderComment.length > 0 ? <div className="tenderComment">Комментарий: { PRODUCT.tenderComment }</div> : null }
                    </td>
                     <td className="cell-center">
                        { PRODUCT.orderAmount }
                    </td>
                    <td className="cell-center">
                        <strong>{ PRODUCT.unit_name }</strong>
                    </td>
                    <td className="cell-center">
                        { PRODUCT.minTenderPrice ? PRODUCT.minTenderPrice + ' руб' : '-'}
                    </td>
                    <td className="cell-center">
                            { !inArchive ?
                            !locked ? <input
                                key={ PRODUCT.id + '_supplier_price' }
                                type="number"
                                min="0"
                                onChange={ input => this.changePrice(input.target.value, PRODUCT.id) }
                                defaultValue={ PRODUCT.orderPrice }
                                className="wideInput"
                            /> : PRODUCT.orderPrice
                            : null }
                    </td>
                    <td className="cell-center">
                            { !inArchive ? 
                            !locked ? <input
                                key={ PRODUCT.id + '_text' }
                                type="text"
                                min="0"
                                onChange={ input => this.changeComment(input.target.value, PRODUCT.id) }
                                defaultValue={ PRODUCT.orderComment }
                                className="wideInput"
                                placeholder="Комментарий ..."
                            /> : PRODUCT.orderComment
                            : null }
                    </td>
                    <td>
                        { inArchive ? <a className="tenderFromArchive" onClick={() => this.removeProductFromArchive(PRODUCT.id)}>Убрать из архива</a> : <a className="tenderToArchive" onClick={() => this.addProductToArchive(PRODUCT.id)}>В архив</a>}
                    </td>
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    renderProductsTableHeader = (SAVEABLE) => {
        return (
            <thead>
                <tr>
                    <th>#</th>
                    <th>фото</th>
                    <th>наименование</th>
                    <th>кол-во</th>
                    <th>Ед. измерения</th>
                    <th>мин цена</th>
                    <th>ваша цена</th>
                    <th>комментарий</th>
                </tr>
            </thead>
        );
    }

    renderProducts = (locked = false) => {
        return (
            <div className="btnTenderHldr">
                <a className={Object.keys(this.state.ARCHIVE).length == 0 ? "tenderArchiveListBtnDisabled" : "tenderArchiveListBtn"} onClick={() => Object.keys(this.state.ARCHIVE).length == 0 ? {} : this.setState({'SHOW_ARCHIVE': true})}>Архив ({Object.keys(this.state.ARCHIVE).length})</a>
                <div className="table_holder">
                    <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                        { this.renderProductsTableHeader() }
                        { this.renderProductsRows(locked) }
                    </table>
                </div>
                { !locked ?
                    <div className="tender_comment_holder">
                        <textarea id="supplierComment" name="supplierComment" placeholder="Комментарий (минимальная сумма, условия поставки, объемы ...)" onChange={(e) => this.setState({COMMENT: e.target.value})}>{this.state.COMMENT}</textarea>
                    </div>
                : this.state.TENDER.tenderComment.length ? <div className="tender_comment_holder">{ this.state.TENDER.tenderComment }</div> : null }
                { !locked && <a className="submit_order_to_suppliers" onClick={ () => this.submitTender() }>Подтвердить</a> }
            </div>
        );
    }

    renderArchiveModal = () =>
    {
        if (!this.state.SHOW_ARCHIVE) {
            return null
        }

        let rows = []
        for (let key in this.state.ARCHIVE) {
            const PRODUCT = this.state.ARCHIVE[key]
            rows.push(
                <tr key={ key }>
                    <td className="cell-center">{ this.renderImage(PRODUCT) }</td>
                    <td><span className="product_title">{ PRODUCT.name }</span></td>
                    <td><a className="tenderFromArchive" onClick={() => this.removeProductFromArchive(PRODUCT.id)}>Убрать из архива</a></td>
                </tr>
            )
        }

        return (
            <div className="archiveBack">
                <div className="archiveBackground" onClick={() => this.setState({'SHOW_ARCHIVE': false})}></div>
                <div className="archiveContent">
                    <div className="archiveBtnHolder">
                        <a onClick={() => this.setState({'SHOW_ARCHIVE': false})}>Закрыть</a>
                    </div>
                    <div className="table_holder">
                    <table id="products_table2" className="products_table" cellPadding="0" cellSpacing="0">
                        <tbody>
                            { rows }
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        if (!this.state.LOADED) {
            return (
                <div className="main_content">
                    <Helmet>
                        <title>Тендер</title>
                    </Helmet>
                    <h1>Тендер</h1>
                    <div className="table_holder"><Loader /><div className="loader_content">Загружаем данные по тендеру ...</div></div>
                </div>
            );
        }

        if (!this.state.TENDER) {
            return (
                <div className="main_content">
                    <Helmet>
                        <title>Тендер</title>
                    </Helmet>
                    <h1>Тендер</h1>
                    <div className="table_holder">К сожалению, данных по тендеру не найдено...</div>
                </div>
            );
        } else {
            return (
                <>
                    <div className="main_content">
                        <Helmet>
                            <title>Тендер №{ this.state.TENDER.id.toString() } / { this.state.TENDER.name }</title>
                        </Helmet>
                        <h1>Тендер №{ this.state.TENDER.id } / { this.state.TENDER.name }</h1>
                        {this.renderStatusBadge(this.state.TENDER.status)}
                        <div className="order_data_block">
                            { this.renderProducts(this.state.TENDER.status == 2 || this.state.TENDER.submitted) }
                            
                            {/* { this.renderTotalsBlock() } */}
                        </div>
                    </div>
                    { this.renderArchiveModal() }
                </>
            );
        }
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Tender))
